import { useContext } from "react";
import TourContext from "../contexts/TourContext";

const useTour = () => {
  return useContext(TourContext);
};

export default useTour;
